import './assets/scss/styles.scss';
require.context('./assets/js/', true, /\.(js)$/im);
